import { render, staticRenderFns } from "./PaymentRequirementAuthentication.vue?vue&type=template&id=4a6f649a&scoped=true&"
import script from "./PaymentRequirementAuthentication.vue?vue&type=script&lang=js&"
export * from "./PaymentRequirementAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequirementAuthentication.vue?vue&type=style&index=0&id=4a6f649a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f649a",
  null
  
)

export default component.exports